import { Box } from '@chakra-ui/react';
import { StorageType } from '@diamond/shared/types';
import { Icon } from '@diamond/shared/ui';

import { STORAGE_CONFIG } from '../OrderStatusIcons';

export interface StorageIconProps {
  storageType: StorageType | null;
}

export function StorageIcon({ storageType }: StorageIconProps) {
  if (!storageType) return null;

  const config = STORAGE_CONFIG[storageType];
  if (!config) return null;

  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w="16px"
      h="16px"
      title={config.label}
      data-testid="storage-icon"
    >
      <Icon as={config.icon} boxSize="16px" color={config.color} />
    </Box>
  );
}
